export{default}from"./SlotsSlider.js";
